import React from 'react';
import ButtonStyles from './Button.module.css';

const Button = ({ label, onClick, disabled = false, style }) => {
	return (
		<button className={ButtonStyles.button} onClick={onClick} disabled={disabled} style={style}>
			{label}
		</button>
	);
};

export default Button;
